import { getLocale } from "../runtime";

const sv_twofor = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `2 för`
};

const twofor = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_twofor(inputs)
	return "twoFor";
};

export { twofor as "twoFor" };